import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
    updateTentSelection
} from "../../../store/checkoutSlice";

const TentPaymentOptions = ({ provider, eventId, isCheckout, isOrders }) => {

    const dispatch = useDispatch();

    const [selectedPct, setSelectedPct] = useState(100);

    const pricing = provider.pricing || {};

    const calculatePrice = (multiplier) => {
        const price = pricing.price || 0;
        const discount = pricing.discountPrice || 0;

        const hasDiscount = discount > 0 && discount < price;

        const base = hasDiscount ? discount : price;

        return {
            original: base * multiplier,
            payable: (pricing.totalAmount || 0) * multiplier,
            savings: base * multiplier - (pricing.totalAmount || 0) * multiplier,
        };
    };

    const baseFull = calculatePrice(1);

    const handleToggle = (value) => {
        if (selectedPct === value) {
            if (!window.confirm("Remove item and order later?")) return;
            setSelectedPct(null);
        } else {
            setSelectedPct(value);
        }

        // 👉 connect redux here
        dispatch(updateTentSelection({ eventId, percentage: value }))
    };

    return (
        <div>

            {/* SERVICES / PACKAGE */}
            {provider.is_package ? (
                <div className="package-box">
                    <p>{provider.package?.package_name}</p>
                </div>
            ) : (
                <ul>
                    {provider.items?.map((item) => (
                        <li key={item.cart_id}>
                            {item.service_name} ({item.quantity})
                        </li>
                    ))}
                </ul>
            )}

            {/* AMOUNT SELECTION */}
            {isCheckout && (
                <div>
                    <p>Choose Amount:</p>

                    {[100, 25, 10].map((val) => (
                        <label key={val}>
                            <input
                                type="radio"
                                checked={selectedPct === val}
                                onChange={() => handleToggle(val)}
                            />
                            {val === 100 ? "Full" : `${val}%`}
                        </label>
                    ))}
                </div>
            )}

            <hr />

            {/* PRICE */}
            {baseFull.savings > 0 ? (
                <>
                    <p style={{ textDecoration: "line-through" }}>
                        ₹{baseFull.original}
                    </p>
                    <p>₹{baseFull.payable}</p>
                    <small>You save ₹{baseFull.savings}</small>
                </>
            ) : (
                <p>Total: ₹{baseFull.original}</p>
            )}

            <p>
                GST: ₹{pricing.gstAmount} ({pricing.gstPercentage}%)
            </p>

            <hr />

            <p><b>Sub Total: ₹{pricing.totalAmount}</b></p>

            {/* PAID */}
            {provider.paid_amount > 0 && (
                <div style={{ color: "green" }}>
                    Paid ₹{provider.paid_amount}
                </div>
            )}

            {/* STATUS */}
            {isCheckout && (
                <p>
                    {isOrders
                        ? provider.balance_to_be_paid > 0
                            ? `Pending ₹${provider.balance_to_be_paid}`
                            : "Fully Paid"
                        : selectedPct !== null
                            ? `To Pay: ₹${provider.paymentSummary?.payable_now || 0}`
                            : "Order Later"}
                </p>
            )}
        </div>
    );
};

export default TentPaymentOptions;